var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageDashboardLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 282,
    viewBox: "0 0 262 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.8359 132.188H36.3516C16.307 132.188 0 115.881 0 95.8359V36.3516C0 16.307 16.307 0 36.3516 0H95.8359C115.881 0 132.188 16.307 132.188 36.3516V95.8359C132.188 115.881 115.881 132.188 95.8359 132.188ZM36.3516 17.625C26.0255 17.625 17.625 26.0255 17.625 36.3516V95.8359C17.625 106.162 26.0255 114.562 36.3516 114.562H95.8359C106.162 114.562 114.562 106.162 114.562 95.8359V36.3516C114.562 26.0255 106.162 17.625 95.8359 17.625H36.3516Z",
    fill: "white",
    fillOpacity: 0.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M245.648 132.188H186.164C166.119 132.188 149.812 115.881 149.812 95.8359V36.3516C149.812 16.307 166.119 0 186.164 0H245.648C265.693 0 282 16.307 282 36.3516V95.8359C282 115.881 265.693 132.188 245.648 132.188ZM186.164 17.625C175.838 17.625 167.438 26.0255 167.438 36.3516V95.8359C167.438 106.162 175.838 114.562 186.164 114.562H245.648C255.974 114.562 264.375 106.162 264.375 95.8359V36.3516C264.375 26.0255 255.974 17.625 245.648 17.625H186.164Z",
    fill: "white",
    fillOpacity: 0.04
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.906 282C179.462 282 149.812 252.35 149.812 215.906C149.812 179.462 179.462 149.812 215.906 149.812C252.35 149.812 282 179.462 282 215.906C282 252.35 252.35 282 215.906 282ZM215.906 167.438C189.181 167.438 167.438 189.181 167.438 215.906C167.438 242.632 189.181 264.375 215.906 264.375C242.632 264.375 264.375 242.632 264.375 215.906C264.375 189.181 242.632 167.438 215.906 167.438Z",
    fill: "white",
    fillOpacity: 0.04
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8359 282H36.3516C16.307 282 0 265.693 0 245.648V186.164C0 166.119 16.307 149.812 36.3516 149.812H95.8359C115.881 149.812 132.188 166.119 132.188 186.164V245.648C132.188 265.693 115.881 282 95.8359 282ZM36.3516 167.438C26.0255 167.438 17.625 175.838 17.625 186.164V245.648C17.625 255.974 26.0255 264.375 36.3516 264.375H95.8359C106.162 264.375 114.562 255.974 114.562 245.648V186.164C114.562 175.838 106.162 167.438 95.8359 167.438H36.3516Z",
    fill: "white",
    fillOpacity: 0.04
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageDashboardLayout);
export default __webpack_public_path__ + "static/media/manageDashboardLayout.b2222bf60469d3bd2847bf955a2e0be7.svg";
export { ForwardRef as ReactComponent };